import { ReplacementOptions } from "./tryOptionalReplacements";

/** commonly occurring phoneme replacements */
export const consonantReplacements: ReplacementOptions[] = [
  {
    ɹ: ['ɾ', 'ɽ', 'r', ['r̪', 'l'], ['ɻ', 'ɭ'], 'ʀ'],
  }
]
export const vowelReplacements: ReplacementOptions[] = [
  {
    ɪ: ['i'], // e is closer in formant-space, but often i is chosen first
  }
]

/**
 * Lentition rules, i.e., consonant weakening
 * source: https://en.wikipedia.org/wiki/Lenition
 */
export const lenition: ReplacementOptions[] = [
  // opening
  {
    h: [''],
    // p
    pː: [['p', 'pʰ'], ['pɸ', 'pf'], ['ɸ', 'f'], 'h', ''],
    p: [['pɸ', 'pf'], ['ɸ', 'f'], 'h', ''],
    pʰ: [['pɸ', 'pf'], ['ɸ', 'f'], 'h', ''],
    pɸ: ['ɸ', 'h', ''],
    ɸ: ['h', ''],
    pf: ['f', 'h', ''],
    f: ['h', ''],
    // t
    tː: [['t', 'tʰ'], ['tθ', 'ts'], ['θ', 's'], 'h', ''],
    t: [['tθ', 'ts'], ['θ', 's'], 'h', ''],
    tʰ: [['tθ', 'ts'], ['θ', 's'], 'h', ''],
    tθ: ['θ', 'h', ''],
    θ: ['h', ''],
    ts: ['s', 'h', ''],
    s: ['h', ''],
    // k
    kː: [['k', 'kʰ'], 'kx', 'x', 'h', ''],
    k: ['kx', 'x', 'h', ''],
    kʰ: ['kx', 'x', 'h', ''],
    kx: ['x', 'h', ''],
    x: ['h', ''],
  },
  // sonorization
  {
    // p
    p: ['b', ['β', 'v'], ['β̞', 'ʋ', 'w'], ''],
    b: [['β', 'v'], ['β̞', 'ʋ', 'w'], ''],
    β: ['β̞', ''],
    v: [['ʋ', 'w'], ''],
    ʋ: [''],
    w: [''],
    // t
    t: ['d', ['ð', 'z', 'ɾ'], ['ð̞', 'ɹ'], ''],
    d: [['ð', 'z', 'ɾ'], ['ð̞', 'ɹ'], ''],
    ð: ['ð̞', ''],
    z: ['ɹ', ''],
    ɾ: ['ɹ', ''],
    ð̞: [''],
    ɹ: [''],
    // k
    k: ['g', 'ɣ', ['ɰ', 'j', 'w'], ''],
    g: ['ɣ', ['ɰ', 'j', 'w'], ''],
    ɣ: [['ɰ', 'j', 'w'], ''],
    ɰ: [''],
    j: [''],
  },
  // vocalization
  {
    l: [['w', 'ɰ', 'j'], ['u', 'o', 'i']],
    w: ['u'],
    ɰ: ['o'],
    j: ['i'],
  }
];
